import { mode } from '@chakra-ui/theme-tools';

const Card = {
  baseStyle: (props) => ({
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '28px',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('rgba(255,255,255,0.9)', 'rgba(16, 23, 40, 0.88)')(props),
    border: '1px solid',
    borderColor: mode(
      'rgba(162, 176, 210, 0.18)',
      'rgba(255,255,255,0.08)',
    )(props),
    boxShadow: mode(
      '0 18px 52px rgba(34, 57, 124, 0.10)',
      '0 22px 54px rgba(2, 8, 23, 0.28)',
    )(props),
    backdropFilter: 'blur(18px)',
    backgroundClip: 'border-box',
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
